module.exports = __webpack_public_path__ + "media/10-day-training-Videos.df405809.mp4";